import { useMemo } from 'react'
import { countOpenTasksByProject } from './spaceSidebarUtils'
import type { ProjectDocument } from '@/lib/db/rxdb/schemas/project'
import { useTasks } from '@/lib/db/rxdb/hooks'
import { useStatuses } from '@/routes/features/tasks/hooks/useWorkspaceStatuses'

/** Open, top-level task counts per project id — one pass over the tasks. */
export function useOpenTaskCounts(): Map<string, number> {
  const { tasks } = useTasks({ isDeleted: false })
  const {
    open: { statusIds },
  } = useStatuses()
  return useMemo(() => countOpenTasksByProject(tasks, statusIds), [tasks, statusIds])
}

/** A space's open tasks: its own plus every project's under it. */
export function spaceOpenCount(
  space: Pick<ProjectDocument, 'id'>,
  projects: ReadonlyArray<Pick<ProjectDocument, 'id' | 'parentProjectId' | 'isDeleted'>>,
  counts: ReadonlyMap<string, number>,
): number {
  let total = counts.get(space.id) ?? 0
  for (const p of projects) {
    if (!p.isDeleted && p.parentProjectId === space.id) total += counts.get(p.id) ?? 0
  }
  return total
}
